module.exports = __webpack_public_path__ + "img/3.daa0aae3.png";